import { faDesktop, faServer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import Lightbox from "react-image-lightbox";
import { Context } from "../../context";
import classes from "./Demo.module.css";
const url = "https://demo-api.davidebalice.dev/api/demo/";

const DemoGallery = ({ slug, selectedTab }) => {
  const { debug, lang } = useContext(Context);
  const [gallery, setGallery] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const lightboxRef = useRef();

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const openLightbox = (index) => {
    setLightboxOpen(true);
    setLightboxIndex(index);
  };

  const getData = async () => {
    try {
      const response = await axios.get(url + slug);
      setGallery(response.data.demo);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedTab === "gallery") {
      getData();
    }
  }, [slug, selectedTab]);

  const CloseLightbox = ({ onClick }) => (
    <button className="lightbox-close-button" onClick={onClick}>
      Close
    </button>
  );

  return (
    <>
      {gallery &&
        gallery.gallery_frontend?.length === 0 &&
        gallery.gallery_backend?.length === 0 && <p>Gallery not found</p>}

      {gallery &&
      gallery.gallery_frontend &&
      gallery.gallery_frontend.length > 0 ? (
        <>
          <p
            className={classes.frontendText}
          >
              <p className={classes.skillTitle}>
                <FontAwesomeIcon icon={faDesktop} /> &nbsp;Frontend
              </p>
           
          </p>
          <div className={classes.demoGallery}>
            {gallery.gallery_frontend.map((img, index) => (
              <div
                key={index}
                className={`${classes.demoGalleryItem} col-12 col-md-4`}
              >
                <img
                  src={`https://demo-api.davidebalice.dev/api/demo/gallery/${img}`}
                  alt="gallery"
                  className={classes.demoGalleryImg}
                  onClick={() => openLightbox(index)}
                />
              </div>
            ))}
          </div>
        </>
      ) : null}

      {gallery && gallery.gallery_frontend?.length > 0 && lightboxOpen && (
        <Lightbox
          ref={lightboxRef}
          mainSrc={`https://demo-api.davidebalice.dev/api/demo/gallery/${gallery.gallery_frontend[lightboxIndex]}`}
          nextSrc={`https://demo-api.davidebalice.dev/api/demo/gallery/${
            gallery[(lightboxIndex + 1) % gallery.gallery_frontend.length]
          }`}
          prevSrc={`https://demo-api.davidebalice.dev/api/demo/gallery/${
            gallery[
              (lightboxIndex + gallery.gallery_frontend.length - 1) %
                gallery.gallery_frontend.length
            ]
          }`}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setLightboxIndex(
              (lightboxIndex + gallery.gallery_frontend.length - 1) %
                gallery.gallery_frontend.length
            )
          }
          onMoveNextRequest={() =>
            setLightboxIndex(
              (lightboxIndex + 1) % gallery.gallery_frontend.length
            )
          }
          closeButtonReplacesBottomButtons={true}
          closeComponent={CloseLightbox}
        />
      )}

      {gallery &&
      gallery.gallery_backend &&
      gallery.gallery_backend.length > 0 ? (
        <>
          <p
            className={classes.backendText}
          >
           
              <p className={classes.skillTitle}>
                <FontAwesomeIcon icon={faServer} /> &nbsp;Backend
              </p>
          
          </p>
          <div className={classes.demoGallery}>
            {gallery.gallery_backend.map((img, index) => (
              <div
                key={index}
                className={`${classes.demoGalleryItem} col-12 col-md-4`}
              >
                <img
                  src={`https://demo-api.davidebalice.dev/api/demo/gallery/${img}`}
                  alt="gallery"
                  className={classes.demoGalleryImg}
                  onClick={() => openLightbox(index)}
                />
              </div>
            ))}
          </div>
        </>
      ) : null}

      {gallery && gallery.gallery_backend?.length > 0 && lightboxOpen && (
        <Lightbox
          ref={lightboxRef}
          mainSrc={`https://demo-api.davidebalice.dev/api/demo/gallery/${gallery.gallery_backend[lightboxIndex]}`}
          nextSrc={`https://demo-api.davidebalice.dev/api/demo/gallery/${
            gallery[(lightboxIndex + 1) % gallery.gallery_backend.length]
          }`}
          prevSrc={`https://demo-api.davidebalice.dev/api/demo/gallery/${
            gallery[
              (lightboxIndex + gallery.gallery_backend.length - 1) %
                gallery.gallery_backend.length
            ]
          }`}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setLightboxIndex(
              (lightboxIndex + gallery.gallery_backend.length - 1) %
                gallery.gallery_backend.length
            )
          }
          onMoveNextRequest={() =>
            setLightboxIndex(
              (lightboxIndex + 1) % gallery.gallery_backend.length
            )
          }
          closeButtonReplacesBottomButtons={true}
          closeComponent={CloseLightbox}
        />
      )}
    </>
  );
};

export default DemoGallery;
